module.exports = __webpack_public_path__ + "files/6aebc8a4331d19618706a547d8cccffe.png";